import api from './api';
import queryString from 'query-string';

const resource = 'OAuth/';

export const callback = async (query) => {
  return await api.get(
    resource +
      `callback?${queryString.stringify(query, {
        skipNull: true,
      })}`
  );
};

export const checkOAuth = async (companyId, query) => {
  return await api.get(resource + 'check-oauth/' + companyId + query);
};

export const disconnectOAuth = async (body) => {
  return await api.post(resource + 'disconnect', body);
};

export const getLocationList = async (query) => {
  return await api.get(
    resource +
      `Get/LocationList?${queryString.stringify(query, {
        skipNull: true,
      })}`
  );
};

// DB-only signal — no Square client call, no token refresh. Safe to call on
// every page view of Menus/Inventory/Import.
export const hasIntegratedStore = async (query) => {
  return await api.get(
    resource +
      `HasIntegratedStore?${queryString.stringify(query, {
        skipNull: true,
      })}`
  );
};

export const postIntegrationStoreLocation = async (body) => {
  return await api.post(resource + 'Post/IntegrationStoreLocation', body);
};

// DB-only: scope list (single source of truth on the api) + proactive
// reconnect signal. Old api without this endpoint => caller falls back.
export const squareConnectInfo = async (query) => {
  return await api.get(
    resource +
      `SquareConnectInfo?${queryString.stringify(query, {
        skipNull: true,
      })}`
  );
};

const oauthApi = {
  callback,
  checkOAuth,
  disconnectOAuth,
  getLocationList,
  hasIntegratedStore,
  postIntegrationStoreLocation,
  squareConnectInfo,
};

export default oauthApi;
